export {};
//# sourceMappingURL=adType.js.map